module.exports = __webpack_public_path__ + "static/media/3C.4281c3d1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/3C.svg
// module id = 57
// module chunks = 0